import React from 'react';
import { Card } from '../ui/Card';
import { Switch } from '../ui/Switch';
import { Button } from '../ui/Button';
import { MultiSelect } from '../ui/MultiSelect';
export interface FilterState {
  loanPurpose: string[];
  leadStatus: string[];
  owner: string[];
  leadSource: string[];
  onlyAnomalies: boolean;
}
interface FilterBarProps {
  filters: FilterState;
  onFilterChange: (filters: FilterState) => void;
  onClearFilters: () => void;
}
const LOAN_PURPOSES = ['Purchase', 'Refinance', 'HELOC', 'Cash-Out Refi'];
const LEAD_STATUSES = ['New', 'Contacted', 'Working', 'Qualified', 'Unqualified'];
export const OWNERS = ['Round Robin Queue', 'Jamie Chen', 'Alex Rivera', 'Marcus Johnson', 'Priya Patel'];
const LEAD_SOURCES = ['Zillow', 'Website', 'Referral', 'Bankrate', 'Realtor.com'];
export function FilterBar({
  filters,
  onFilterChange,
  onClearFilters
}: FilterBarProps) {
  const update = <K extends keyof FilterState,>(key: K, value: FilterState[K]) => {
    onFilterChange({
      ...filters,
      [key]: value
    });
  };
  return <Card className="p-3 mb-6 bg-white overflow-visible" data-id="element-94">
      <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-4" data-id="element-95">
        <div className="flex flex-wrap items-center gap-3" data-id="element-96">
          <MultiSelect label="Loan Purposes" options={LOAN_PURPOSES} values={filters.loanPurpose} onChange={v => update('loanPurpose', v)} data-id="element-97" />
          <MultiSelect label="Statuses" options={LEAD_STATUSES} values={filters.leadStatus} onChange={v => update('leadStatus', v)} data-id="element-98" />
          <MultiSelect label="Owners" options={OWNERS} values={filters.owner} onChange={v => update('owner', v)} data-id="element-99" />
          <MultiSelect label="Sources" options={LEAD_SOURCES} values={filters.leadSource} onChange={v => update('leadSource', v)} data-id="element-100" />
        </div>

        <div className="flex items-center gap-4 pl-2 lg:border-l lg:border-slate-200" data-id="element-101">
          <div className="flex items-center gap-2" data-id="element-102">
            <Switch checked={filters.onlyAnomalies} onCheckedChange={checked => update('onlyAnomalies', checked)} id="anomaly-toggle" data-id="element-103" />
            <label htmlFor="anomaly-toggle" className="text-sm font-medium text-slate-700 cursor-pointer select-none" data-id="element-104">
              Only Show Anomalies
            </label>
          </div>

          <Button variant="ghost" size="sm" onClick={onClearFilters} className="text-slate-500 hover:text-slate-900" data-id="element-105">
            Clear Filters
          </Button>
        </div>
      </div>
    </Card>;
}